"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExtendedBillingUser = exports.ISearchBillingUsersRequest = exports.IBillingUser = exports.TargetUsersEnum = void 0;
const orgUserRole_1 = require("../../../hub/models/api/orgUserRole");
const user_1 = require("../../../hub/models/api/user");
const openapi_1 = require("../../../openapi");
var TargetUsersEnum;
(function (TargetUsersEnum) {
    TargetUsersEnum["ALL"] = "ALL";
    TargetUsersEnum["C1"] = "C1";
    TargetUsersEnum["C2"] = "C2";
})(TargetUsersEnum = exports.TargetUsersEnum || (exports.TargetUsersEnum = {}));
class IBillingUser extends orgUserRole_1.IOrgUserRole {
    appData;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'object' })
], IBillingUser.prototype, "appData", void 0);
exports.IBillingUser = IBillingUser;
class ISearchBillingUsersRequest {
    targetUsers;
    customerIds;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(TargetUsersEnum) })
], ISearchBillingUsersRequest.prototype, "targetUsers", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], ISearchBillingUsersRequest.prototype, "customerIds", void 0);
exports.ISearchBillingUsersRequest = ISearchBillingUsersRequest;
let IExtendedBillingUser = class IExtendedBillingUser {
};
IExtendedBillingUser = __decorate([
    (0, openapi_1.Include)(user_1.IUser, IBillingUser)
], IExtendedBillingUser);
exports.IExtendedBillingUser = IExtendedBillingUser;
